import * as api from '../api'

export const getNotices = () => async (dispatch) => {
  try {
    const { data } = await api.fetchNotices()
    dispatch({ type: 'FETCH_NOTICES', payload: data })
  } catch (error) {
    dispatch({
      type: 'API_ERROR',
      payload: error,
    })
  }
}
